import { useParams } from 'react-router-dom';

export const useProductIdParam = () => {
  const { id } = useParams();

  return { productId: Number(id) };
};
